export const getInitials = (fullName: string) => {
  if (!fullName) return "";
  const words = fullName.trim().split(" ");
  return words
    .slice(0, 2)
    .map((word) => word[0].toUpperCase())
    .join("");
};

export const formatNumber = (value: number | string) => {
  if (!value) return "0";

  return new Intl.NumberFormat("en-US").format(Number(value));
};

export const formatStatus = (status?: string | null) => {
  if (!status) return "";
  return status
    .toLowerCase()
    .replace(/_/g, " ")
    // .replace(/\b\w/g, (c) => c.toUpperCase());
};
